import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PagingRadioButton = /*#__PURE__*/function (_Component) {
  function PagingRadioButton(props) {
    var _this;
    _classCallCheck(this, PagingRadioButton);
    _this = _callSuper(this, PagingRadioButton, [props]);
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleAdd = _this.handleAdd.bind(_this);
    _this.scrollRef = /*#__PURE__*/React.createRef();
    _this.state = {
      buttons: [],
      currentSelected: null
    };
    return _this;
  }
  _inherits(PagingRadioButton, _Component);
  return _createClass(PagingRadioButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var defaultSelected = this.props.defaultSelected;
      this.updateWholeArray();
      this.handleToggle(defaultSelected);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        defaultSelected = _this$props.defaultSelected,
        maxPageCount = _this$props.maxPageCount,
        isAddEnable = _this$props.isAddEnable,
        minPageEnabled = _this$props.minPageEnabled,
        defaultPageShowed = _this$props.defaultPageShowed;
      if (defaultSelected !== prevProps.defaultSelected || maxPageCount !== prevProps.maxPageCount || isAddEnable !== prevProps.isAddEnable || minPageEnabled !== prevProps.minPageEnabled || defaultPageShowed !== prevProps.defaultPageShowed) {
        this.updateWholeArray();
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(index) {
      var updateSelected = this.props.updateSelected;
      this.setState({
        currentSelected: index
      });
      updateSelected(index);
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      var _this2 = this;
      var buttons = this.state.buttons;
      this.setState({
        buttons: buttons.filter(function (button) {
          return button.text !== '+';
        }).map(function (button) {
          return _objectSpread(_objectSpread({}, button), {}, {
            hide: false
          });
        })
      }, function () {
        _this2.scrollRef.current.scrollLeft += _this2.scrollRef.current.clientWidth / 7;
      });
    }
  }, {
    key: "updateWholeArray",
    value: function updateWholeArray() {
      var newArray = [];
      var _this$props2 = this.props,
        maxPageCount = _this$props2.maxPageCount,
        minPageEnabled = _this$props2.minPageEnabled,
        isAddEnable = _this$props2.isAddEnable,
        defaultPageShowed = _this$props2.defaultPageShowed,
        defaultSelected = _this$props2.defaultSelected;
      var i = 1;
      var addButtonShow = false;
      var parsedDefaultPageShowed = Math.max(defaultPageShowed, defaultSelected, minPageEnabled);
      while (i <= maxPageCount) {
        if (isAddEnable && !addButtonShow && i === parsedDefaultPageShowed + 1) {
          newArray.push({
            text: '+',
            isDisabled: i < minPageEnabled,
            isAdd: true,
            hide: false
          });
          addButtonShow = true;
        } else if (isAddEnable && i >= parsedDefaultPageShowed + 1) {
          newArray.push({
            text: i,
            isDisabled: i < minPageEnabled,
            isAdd: false,
            hide: true
          });
          i += 1;
        } else {
          newArray.push({
            text: i,
            isDisabled: i < minPageEnabled,
            isAdd: false,
            hide: false
          });
          i += 1;
        }
      }
      this.setState({
        buttons: newArray,
        currentSelected: minPageEnabled > defaultSelected ? minPageEnabled : defaultSelected
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var dataTest = this.props.dataTest;
      var _this$state = this.state,
        currentSelected = _this$state.currentSelected,
        buttons = _this$state.buttons;
      var buttonElements = buttons.map(function (button, index) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          isToggled: currentSelected === index + 1,
          handleToggle: button.isAdd ? _this3.handleAdd : _this3.handleToggle,
          text: button.text,
          isDisabled: button.isDisabled,
          hide: button.hide,
          ref: _this3.scrollRef,
          key: button.text
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "pagingRadioButtonContainer",
        ref: this.scrollRef,
        "data-test": dataTest
      }, buttonElements);
    }
  }]);
}(Component);
var string = PropTypes.string,
  bool = PropTypes.bool,
  func = PropTypes.func,
  number = PropTypes.number;
/*
Props definition:
    updatedSelected: callback function for parents to get selected values
    defaultSelected: the page that will be selected by default at render
    maxPageCount: max number of pages we are going to show eventually
    isAddEnable: enable the add button to display more pages, otherwise it will just show all the pages at once
    minPageEnabled: the smallest page button we want to enable. the buttons before this number will be disable
    defaultPageShowed: the number of pages we want to show by default before expended by the add button
    
*/
PagingRadioButton.propTypes = {
  updateSelected: func.isRequired,
  dataTest: string,
  isAddEnable: bool,
  defaultSelected: number,
  minPageEnabled: number,
  maxPageCount: number,
  defaultPageShowed: number
};
PagingRadioButton.defaultProps = {
  dataTest: 'paging-button-group',
  isAddEnable: true,
  defaultPageShowed: 4,
  defaultSelected: 2,
  minPageEnabled: 2,
  maxPageCount: 10
};

export { PagingRadioButton as default };
